export const delay = (timeout: number) =>
  new Promise((resolve) => setTimeout(resolve, timeout));

const loadImage = (url: string): Promise<void> =>{
  return new Promise((resolve, reject)=>{
    const img = new Image();
    img.src = url;
    img.onload = ()=> {
      resolve();
    }
    img.onerror = () =>  {
      reject(new Error('failed'));
    }
  });
}
export const preloadImages = (urls: string[]) => {
  const promise = urls.map(url => loadImage(url));
  return Promise.all(promise);
};
